import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

@Component({
    selector: 'app-pessoa-hierarchical-dropdown',
    templateUrl: './pessoa-hierarchical-dropdown.component.html',
    styleUrls: ['./pessoa-hierarchical-dropdown.component.css']
})
export class PessoaHierarchicalDropdownComponent implements OnInit {

    public labelSelecionado;

    public searchTerm='';

    public open = false;

    public pessoas = [
        {
          id: 1,
          nome: 'CERAMICA CHIARELLI S/A',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 2,
          nome: 'ONCO PROD DISTRIBUIDORA DE PRODUTOS HOSPITALARES',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 3,
          nome: 'ASPEN PHARMA INDÚSTRIA FARMACÊUTICA LTDA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 4,
          nome: 'CAPSUGEL BRASIL IMPORTAÇÃO E DISTRIBUIÇÃO',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 5,
          nome: 'WISECASE IND. E COM. ELETRONICO LTDA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 6,
          nome: 'BIOSYS LTDA (GRUPO KOVALENT)',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 7,
          nome: 'MARTELL COMERCIO DE PRODUTOS HOSPITALARES',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 8,
          nome: 'PUROLITE DO BRASIL LTDA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 9,
          nome: 'NOVARTIS BIOCIENCIAS SA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 10,
          nome: 'EUROFARMA LABORATORIOS SA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 11,
          nome: 'PFIZER BRASIL LTDA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 12,
          nome: 'EMS S/A',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 13,
          nome: 'ACHE LABORATORIOS FARMACEUTICOS',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 14,
          nome: 'SANOFI MEDLEY',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 15,
          nome: 'HYPERA PHARMA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 16,
          nome: 'BAYER S.A.',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 17,
          nome: 'ROCHE FARMACEUTICA',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 18,
          nome: 'GLAXOSMITHKLINE',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 19,
          nome: 'JOHNSON & JOHNSON',
          expanded: false,
          unidades: null,
          hasChildren: true
        },
        {
          id: 20,
          nome: 'ABBOTT LABORATORIOS',
          expanded: false,
          unidades: null,
          hasChildren: true
        }
      ];

    @HostListener('document:click', ['$event'])
    clickOutside(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.open = false;
        }
    }

    constructor(private elementRef: ElementRef) { }

    ngOnInit(): void {
    }

    toggle() {
        this.open = !this.open;
    }

    onSearch(){}

    togglePessoa(pessoa: any){
        pessoa.expanded = !pessoa.expanded;
        

        if (pessoa.expanded && !pessoa.unidades) {
            setTimeout(() => {
              pessoa.unidades = [
                {
                  id: 101,
                  nome: 'Filial São Paulo',
                  expanded: false,
                  grupos: null
                },
                {
                  id: 102,
                  nome: 'Filial Rio de Janeiro',
                  expanded: false,
                  grupos: null
                },
                {
                  id: 103,
                  nome: 'Filial Minas Gerais',
                  expanded: false,
                  grupos: null
                }
              ];
            }, 500);
          }
    }
    
    select(pessoa: any){}

}
